import { render } from "./SkipToMainContent.vue?vue&type=template&id=9bd6884c&scoped=true"
const script = {}

import "./SkipToMainContent.vue?vue&type=style&index=0&id=9bd6884c&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd6884c"]])

export default __exports__